import { Uniswap } from '../../../Fct/Fct';
import createMulticallPlugin from './generic/createMulticallPlugin';
import { Approve } from '../ERC20/actions/approve';
export var ApprovedSwap = createMulticallPlugin({
    plugin: [Approve, Uniswap.actions.SimpleSwapV2],
    protocol: 'KIROBO_MULTICALL',
    type: 'LIBRARY',
    method: 'multiCall',
    name: 'approvedSwap',
    config: {
        params: [
            // Approve
            { key: 'to', multicallKey: 'tokenToApprove' },
            { key: 'methodParams.spender', multicallKey: 'tokenSpender' },
            { key: 'methodParams.amount', multicallKey: 'amountToApprove' },
            // Swap
            { key: 'isExactIn', multicallKey: 'isExactIn' },
            { key: 'snipperMode', multicallKey: 'snipperMode' },
            { key: 'addressIn', multicallKey: 'addressIn' },
            { key: 'amountIn', multicallKey: 'amountIn' },
            { key: 'addressOut', multicallKey: 'addressOut' },
            { key: 'amountOut', multicallKey: 'amountOut' },
            { key: 'methodParams.to', multicallKey: 'recipient' },
        ],
        tupleName: 'approvedSwaps',
    },
    addPluginOnInit: true,
    withPluginOutputs: true,
});
